import type { Contract } from '../types';

export const PRE_BID_MEETING_LISTED = 'Listed';
export const PRE_BID_MEETING_NOT_LISTED = 'Not listed';
export const PRE_BID_MEETING_OPTIONS = [PRE_BID_MEETING_LISTED, PRE_BID_MEETING_NOT_LISTED];

export const hasPreBidMeeting = (contract: Pick<Contract, 'has_pre_bid_meeting' | 'pre_bid_meeting'>) => {
  if (typeof contract.has_pre_bid_meeting === 'boolean') {
    return contract.has_pre_bid_meeting;
  }
  return Boolean(contract.pre_bid_meeting?.trim());
};

export const getPreBidMeetingFilterValue = (contract: Pick<Contract, 'has_pre_bid_meeting' | 'pre_bid_meeting'>) =>
  hasPreBidMeeting(contract) ? PRE_BID_MEETING_LISTED : PRE_BID_MEETING_NOT_LISTED;
